export default "__VITE_ASSET__WJPP9hj$__"